import { TReportsListItemProps } from "../../../../Types";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import AuditActions from "./audit-actions";
import ReportNumber from "./report-number";

const ReportTitleDateAndNumber =
  withLiteObserverAndTheme<TReportsListItemProps>((props) => {
    const {
      report,
      status,
      pageName,
      eventID,
      takenActionType,
      date,
      reportNumberFromPartition,
      reportsPartitionMaxNumber,
      theme
    } = props;
    const { colors } = theme;
    const { reportedId, reportedUUID } = report;

    return (
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="row"
        justifyContent="space-around"
        alignItems="center"
        withShadow={false}
        width={1000}
        height={50}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        {date}
        <ReportNumber
          pageName={pageName}
          status={status}
          reportNumberFromPartition={reportNumberFromPartition}
          reportsPartitionMaxNumber={reportsPartitionMaxNumber}
        />
        <AuditActions
          pageName={pageName}
          eventID={eventID}
          reportedId={reportedId}
          reportedUUID={reportedUUID}
          takenActionType={takenActionType}
        />
      </ET3Div>
    );
  });
export default ReportTitleDateAndNumber;
